// ================ ROUTES  =================
export const R_DASHBOARD = "/admin";
export const R_DASHBOARD_PROTO = "/admin/dashboard-proto";
export const R_COMPANIES = "/admin/empresas-cadastradas";
export const R_ADD_COMPANIES = "/admin/adicionar_empresa";
export const R_AUDIOFOCO_USERS = "/admin/audiofoco-usuarios";
export const R_REWARDS = "/admin/recompensas";
export const R_ADD_REWARDS = "/admin/adicionar_recompensas";
export const R_EDIT_REWARDS = (reward_id) =>
  `/admin/editar_recompensa/${reward_id}`;
export const R_PLANS_USERS = "/admin/planos-do-usuario";
export const R_PLANS_CANCEL = "/admin/cancelar-plano";
export const R_DELETE_USER = "/admin/excluir-usuario";
export const R_GET_USER_DETAILS = (email) =>
  `/admin/planos-do-usuario/details/${email}`;

export const R_ACTIVITIES = "/admin/atividades";
export const R_ADD_ACTIVITIES = "/admin/adicionar_atividades";
export const R_EDIT_ACTIVITIES = (activity_id) =>
  `/admin/editar_atividades/${activity_id}`;
export const R_SYNC_ACTIVITIES = "/admin/sincronizar_atividades";

export const R_BANNERS = "/admin/banners";
export const R_ADD_BANNERS = "/admin/adicionar_banner";
export const R_EDIT_BANNERS = (banner_id) =>
  `/admin/editar_banner/${banner_id}`;

export const R_EVENTS = "/admin/eventos";
export const R_ADD_EVENTS = "/admin/adicionar_evento";
export const R_EDIT_EVENTS = (event_id) =>
  `/admin/editar_evento/${event_id}`;

export const R_AUDBILITY_USERS = "/admin/audbility-usuarios";
export const R_AUDBILITY_USER_DETAILS = (sub) =>
  `/admin/audbility-usuarios/details/${sub}`;
export const R_AUDBILITY_VALIDATE_CRFA = "/admin/audbility-validar-crfa";